if (!customElements.get("cross-sell-builder")) {
  customElements.define(
    "cross-sell-builder",
    class CrossSellBuilder extends HTMLElement {
      constructor() {
        super();
        this.main_product_form =
          this.closest(".product").querySelector('.product-form form[action*="/cart/add"]') ||
          document.querySelector('.product__page form[action*="/cart/add"]') ||
          document.querySelector('.product form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add.js"]') ||
          document.querySelector('form[action*="/cart/add"]');
        if (this.main_product_form === null) return console.error("Cross Sell Builder: No product form found");
      }

      connectedCallback() {
        // Listen for changes in the quantity input
        this.querySelectorAll(".csb_variant").forEach((variant) => {
          if (variant.querySelector(".deployer-quantity") != null) {
            variant.querySelector("input").addEventListener("change", this.onInputQuantityChange.bind(this, variant));
            variant.querySelectorAll("button").forEach((button) => {
              button.addEventListener("click", (event) => {
                this.onButtonQuantityClick(event.target, variant);
              });
            });
          }
        });
        this.bindSubscriptionSync();
        this.updateEverything();
      }

      bindSubscriptionSync() {
        if (this.dataset.syncSubscription !== 'true' || this.subscriptionSyncBound) return;

        document.addEventListener('subscription:plan-change', () => {
          this.addSelectionToForm();
        });
        this.subscriptionSyncBound = true;
      }

      getSyncedSellingPlanId() {
        if (this.dataset.syncSubscription !== 'true') return '';

        const widget = document.querySelector('subscription-widget');
        if (!widget) return '';

        const selectedOption = widget.querySelector('.subscription-widget__option--selected');
        if (!selectedOption || !selectedOption.classList.contains('subscription-widget__option--subscription')) return '';

        const select = selectedOption.querySelector('.select__select');
        if (!select) return '';

        return select.options[select.selectedIndex]?.dataset.value || '';
      }

      validateQtyAvailability(variant) {
        const input = variant.querySelector(".deployer-quantity input");
        const value = parseInt(input.value);
        if (value > parseInt(input.max)) {
          input.value = parseInt(input.max);
          variant.querySelector('.deployer-quantity button[name="plus"]').disabled = true;
        }
      }

      onInputQuantityChange(variant) {
        this.validateQtyAvailability(variant);
        this.updateEverything();
      }

      onButtonQuantityClick(element_clicked, variant) {
        const input = variant.querySelector(".deployer-quantity input");
        variant.querySelectorAll(".deployer-quantity button").forEach((button) => (button.disabled = false));
        if (element_clicked.name === "plus") {
          if (parseInt(input.value) < parseInt(input.max) || parseInt(input.max) == 0) input.stepUp();
          if (parseInt(input.value) == parseInt(input.max)) element_clicked.disabled = true;
          variant.classList.add('selected');
        } else {
          if (parseInt(input.value) > parseInt(input.min)) input.stepDown();
          if (parseInt(input.value) == 0) variant.classList.remove('selected');
        }
        this.updateEverything();
      }

      updateEverything() {
        this.addSelectionToForm();
        this.updateJauge();
        this.updateJaugeMessage();
        this.updateResume();
      }

      resetMainFormInputs() {
        const sellingPlanId = this.getSyncedSellingPlanId();
        if (this.main_product_form.querySelector('[name="selling_plan"]') && sellingPlanId != '') this.main_product_form.querySelector('[name="selling_plan"]').remove();
        document.querySelectorAll(".from-variant-builder").forEach((input) => input.remove());
      }

      addSelectionToForm() {
        this.resetMainFormInputs();
        var index = 0;
        const sellingPlanId = this.getSyncedSellingPlanId();
        this.querySelectorAll(".deployer-quantity input").forEach((input) => {
          if (input != null && input.value > 0) {
            let fields = `<input type="hidden" class="from-variant-builder" name="items[${index}][id]" value="${input.dataset.variantId}"><input type="hidden" class="from-variant-builder" name="items[${index}][quantity]" value="${input.value}">`;
            if (sellingPlanId) {
              fields += `<input type="hidden" class="from-variant-builder" name="items[${index}][selling_plan]" value="${sellingPlanId}">`;
            }
            this.main_product_form.insertAdjacentHTML("beforeend", fields);
            index++;
          }
        });
      }

      updateJauge() {
        var reste = this.getNumberOfSelectedVariants();
        const progressContainer = this.querySelector(".csb_progress-container");
        let allComplete = true;
        
        this.querySelectorAll(".csb_progress-group").forEach((progressGroup) => {
          const progress = progressGroup.querySelector("progress");
          progressGroup.querySelectorAll(".csb_progress-title").forEach((title) => title.classList.remove("csb_progress-title--active"));
          if (reste > 0) {
            if (reste >= progress.dataset.max) {
              progress.value = 100;
              reste -= progress.dataset.max;
              progressGroup.querySelectorAll(".csb_progress-title").forEach((title) => title.classList.add("csb_progress-title--active"));
            } else {
              progress.value = 100 * (reste / progress.dataset.max);
              reste = 0;
              allComplete = false;
            }
          } else {
            progress.value = 0;
            allComplete = false;
          }
        });

        if (progressContainer) {
          if (allComplete && this.getNumberOfSelectedVariants() > 0) {
            progressContainer.classList.add("csb_progress-container--complete");
          } else {
            progressContainer.classList.remove("csb_progress-container--complete");
          }
        }
      }

      updateJaugeMessage() {
        const messageContainer = this.querySelector(".csb_jauge-message");
        if (!messageContainer) return;

        const selectedCount = this.getNumberOfSelectedVariants();
        let message = "";
        let currentPalierIndex = -1;

        for (let i = 0; i < paliers_reduction.length; i++) {
          if (selectedCount >= paliers_reduction[i].quantity) {
            currentPalierIndex = i;
          }
        }

        const lastPalierIndex = paliers_reduction.length - 1;
        const isLastPalierReached = currentPalierIndex >= 0 && currentPalierIndex === lastPalierIndex;

        if (isLastPalierReached) {
          message = messageContainer.dataset.messageFinal || "";
        } else {
          const nextPalierIndex = currentPalierIndex + 1;
          if (nextPalierIndex < paliers_reduction.length) {
            message = messageContainer.dataset[`messagePalier${nextPalierIndex + 1}`] || "";
          }
        }

        messageContainer.textContent = message;
        messageContainer.style.display = message ? "block" : "none";
      }

      updateResume() {
        // Nombre d'unités
        if (this.querySelector(".csb_resume-nombre-unite") != null) {
          const unitLabel = this.querySelector(".csb_resume-nombre-unite #unitLabel");
          const unitQuantity = this.querySelector(".csb_resume-nombre-unite #unitQuantity");
          unitQuantity.innerHTML = this.getNumberOfSelectedVariants();
          if (this.getNumberOfSelectedVariants() > 1) {
            unitLabel.innerHTML = unitLabel.dataset.labelPluriel;
          } else {
            unitLabel.innerHTML = unitLabel.dataset.labelSingulier;
          }
        }

        // Nombre de sous-unités
        if (this.querySelector(".csb_resume-nombre-sous-unite") != null) {
          const sousUnitLabel = this.querySelector(".csb_resume-nombre-sous-unite #sousUnitLabel");
          const sousUnitQuantity = this.querySelector(".csb_resume-nombre-sous-unite #sousUnitQuantity");
          const totalSousUnit = this.getNumberOfSelectedVariants() * parseInt(sousUnitLabel.dataset.unitFactor);
          sousUnitQuantity.innerHTML = totalSousUnit;
          if (totalSousUnit > 1) {
            sousUnitLabel.innerHTML = sousUnitLabel.dataset.labelPluriel;
          } else {
            sousUnitLabel.innerHTML = sousUnitLabel.dataset.labelSingulier;
          }
        }

        // Prix par unité
        if (this.querySelector(".csb_resume-unite-price") != null) {
          const priceByUnit = this.querySelector(".csb_resume-unite-price #priceByUnit");
          if (this.getNumberOfSelectedVariants() === 0) {
            priceByUnit.innerHTML = "";
          } else {
            priceByUnit.innerHTML = formatPrice(this.getPriceByUnit()) + " " + priceByUnit.dataset.label;
          }
        }
      }

      getNumberOfSelectedVariants() {
        var totalSelectedVariants = 0;
        this.querySelectorAll(".deployer-quantity input").forEach((input) => {
          totalSelectedVariants += parseInt(input.value);
        });
        return totalSelectedVariants;
      }

      getSelectionTotalPrice() {
        var total = 0;
        this.querySelectorAll(".csb_variant").forEach((variant) => {
          if (variant.querySelector(".deployer-quantity input") != null) {
            const price = parseInt(variant.dataset.variantPrice);
            const quantity = parseInt(variant.querySelector(".deployer-quantity input").value);
            total += price * quantity;
          }
        });
        return total;
      }

      getSelectionTotalDiscountedPrice() {
        var reachedDiscount = 0;
        paliers_reduction.forEach((palier) => {
          if (this.getNumberOfSelectedVariants() >= palier.quantity) {
            reachedDiscount = palier.discount;
          }
        });

        var discountedTotal = 0;
        this.querySelectorAll(".csb_variant").forEach((variant) => {
          if (variant.querySelector(".deployer-quantity input") != null) {
            const price = parseInt(variant.dataset.variantPrice);
            const quantity = parseInt(variant.querySelector(".deployer-quantity input").value);
            const variant_discounted_price = (price - (price * reachedDiscount) / 100).toFixed(0);
            discountedTotal += variant_discounted_price * quantity;
          }
        });
        return discountedTotal;
      }

      getPriceByUnit() {
        return this.getSelectionTotalDiscountedPrice() / this.getNumberOfSelectedVariants();
      }
    }
  );
}

function formatPrice(cents) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = "${{amount}}";

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
